import { Observable } from 'rxjs';
import { Api } from '../_services/api';
import { Injectable } from '@angular/core';

@Injectable()
export class ApptApi {
    constructor(private api: Api) {

    }

    list(date, lid, pid): Observable<any[]> {
        return this.api.post<any[]>("/appointment/list", { date: date, loc_id: lid, p_id: pid });
    };

    search(loc_id: string, pack_id: string, status_id: number | string, sdate: Date, edate: Date, name: string) {
        return this.api.post<any[]>("/appointment/search", {
            location_id: loc_id, package_id: pack_id, status_id: status_id, sdate: sdate, edate: edate, name: name
        });
    }

    listByUser() {
        return this.api.get("/booking/history", null);
    }

    listApptDashboard(loc_id, pack_id, date) {
        return this.api.post<any[]>("/appointment/location/get", { location_id: loc_id, package_id: pack_id, date: date });
    }

    listAvailableDashboard(loc_id, pack_id, date) {
        return this.api.post<any[]>("/appointment/available/get", { location_id: loc_id, package_id: pack_id, date: date });
    }

    getHoliday(id) {
        return this.api.post("/appointment/location/holiday/get", { id: id });
    }

    getDayOff(lid, pid) {
        return this.api.post("/appointment/dayOff/get", { location_id: lid, package_id: pid });
    }

    getLocation(): Observable<any[]> {
        return this.api.get<any[]>("/appointment/group/location/list", null);
    }

    getPackageType(){
        return this.api.get("/appointment/packagetype/list", null);
    }

    getPackage(location_id, type_id?): Observable<any[]> {
        let param: any = {};
        if (location_id) param.id = location_id;
        if (type_id) param.type_id = type_id;

        return this.api.post<any[]>("/appointment/location/packages/get", param);
    };

    getTime(date, loc, pack) {
        return this.api.post<any[]>("/appointment/location/packages/available/get", { location_id: loc, package_id: pack, date: date });
    }

    getForm() {
        return this.api.get<any[]>("/appointment/form/list", null);
    }

    create(data: {
        date_time: Date, user_id: string, location_id: string, package_id: string, form_value: any, user: any
        // , 'g-recaptcha-response': any
    }) {
        return this.api.post("/appointment/add", data);
    }

    summary() {
        return this.api.get('/booking/count', null);
    }

    pendingCount() {
        return this.api.get('/booking/count/pending', null);
    }

    get(ref) {
        return this.api.post("/booking/get", { ref: ref });
    }

    getHistory(ref) {
        return this.api.post("/booking/history/ref", { ref: ref });
    }

    confirm(ref) {
        return this.api.post("/booking/confirm", { ref: ref });
    }

    confirmReschedule(ref) {
        return this.api.post("/booking/reschedule/confirm", { ref: ref });
    }

    confirmCancel(ref) {
        return this.api.post("/booking/cancel/confirm", { ref: ref });
    }

    reject(ref) {
        return this.api.post("/booking/reject", { ref: ref });
    }

    cancel(ref) {
        return this.api.post('/booking/cancel/request', { ref: ref });
    }

    delete(ref) {
        return this.api.post('/booking/delete', { ref: ref });
    }

    getFormValue(ref) {
        return this.api.post("/form/value/get", { ref_no: ref });
    }

    verify(token) {
        return this.api.post("/appointment/siteverify", { "g-recaptcha-response": token });
    }

    reschedule(ref, lid, pid, date) {
        return this.api.post('/booking/reschedule/request', { ref: ref, date_time: date, location_id: lid, package_id: pid });
    }

    rescheduleAdmin(ref, lid, pid, date) {
        return this.api.post('/booking/reschedule', { ref: ref, date_time: date, location_id: lid, package_id: pid });
    }

    test(lid, pid, date) {
        return this.api.post('/test/book', { location_id: lid, package_id: pid, date_time: date });
    }
    // create(data: any): Observable<any> {
    //     return this.api.post("/holiday/add", data);
    // };

    // delete(id: any): Observable<any> {
    //     return this.api.post("/holiday/delete", { id: id });
    // }

    // get(id: number): Observable<any> {
    //     let options = { param: { id: id } };

    //     return this.api.get<any>("/packages/id", options);
    // }

    // create(data: any): Observable<any> {
    //     return this.api.post("/packages/add", data);
    // }

    // update(data: any): Observable<any> {
    //     return this.api.post("/packages/edit", data);
    // }

    // delete(id: number) {
    //     return this.api.post("/packages/delete", { id: id });
    // }
}


// WEBPACK FOOTER //
// ./src/app/api/api-appt.ts